import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

const SurveySubmissionStatus = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // status: 'success' | 'cancel' | 'error', message: string
    const { status = 'success', message = '' } = location.state || {};

    let resultProps = {
        status: 'success',
        title: 'Survey Submitted!',
        subTitle: 'Thank you for completing the survey. Your responses have been received.'
    };
    if (status === 'cancel') {
        resultProps = {
            status: 'info',
            title: 'Survey Cancelled',
            subTitle: 'You have cancelled the survey. No data was saved.'
        };
    } else if (status === 'error') {
        resultProps = {
            status: 'error',
            title: 'Submission Failed',
            subTitle: message || 'There was a problem submitting your survey. Please try again.'
        };
    }

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Result
                status={resultProps.status}
                title={resultProps.title}
                subTitle={resultProps.subTitle}
            />
        </div>
    );
};

export default SurveySubmissionStatus;
